<template>
  <div class="tab-pane fade  " id="warning-close-violation" role="tabpanel"
    aria-labelledby="warning-close-violation-tab">
    
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">請選擇</option>
            <option v-for="(list, index) in violationScenicArea" :key="index" :value="list.id">{{ list.name }}</option>
          </select>
        </div>

        <!-- <div class="col-md-2">
          <label for="inputEmail4" class="form-label">違規類型</label>
          <select class="form-control" v-model.number="selectViolationType">
            <option value="-1">請選擇</option>
            <option v-for="(list, index) in violationTypeList" :key="index" :value="list.id">{{ list.description }}</option>
          </select>
        </div> -->

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk"
            :disabled="isWaitResult">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV"
            :disabled="isWaitResult">
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">預警封閉查詢</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="warningCloseTable" :class="tableStyle">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">風景區</th>
                    <th scope="col">設備地點</th>
                    <th scope="col">時間</th>
                    <th scope="col">違規類型</th>
                    <th scope="col" v-show ="isShortView">影像路徑</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in violationList" :key="index" :class="tableCenterStyle">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.areaName }}</td>
                    <td>{{item.publicPlaceName}}</td>
                    <td>{{ getTime(item) }}</td>
                    <td>{{ UTILS.getViolationType(item.violationType) }} <br/>{{getPlate(item.licensePlate)}}
                      <div v-show ="!isShortView">
                        <a class=" px-1 mx-1mt-1" :href="getElkImgHypeLink(item)" target="_blank">
                        <div class="btn-search text-primary">
                          <i class="fas fa-search"></i> 
                          <!-- <p class="mb-0 btn-text">查看</p> -->
                        </div> 

                        </a>
                      </div>
                    </td>
                    <td v-show ="isShortView">
                      <a :href="getElkImgHypeLink(item)" target="_blank">
                        <img :src='getElkImgUrl(item)'  style="width:100%" > 
                         <!-- @click="selectImg(item)" -->
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

    </div>

    <dialog-modal ref="violationDetail" :showUpdateButton="false" :customUpdateButton="123" :modalSize="'xl'"
      :isImage="true" :isMarginAuto="true">
      <div class="object-detection-detail" v-if="ratioData != null">
        <!-- using v-if for avoid to canvas is not defined -->
        <div class="border-bottom pb-1">
          <img :src='ratioData.image.src' :width="ratioData.image.width" :height="ratioData.image.height">
        </div>
      </div>
    </dialog-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from "moment";
import DialogModal from '../../components/DialogModal.vue'
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'

export default {
  name: "Home",
  components: { DialogModal },
  data() {
    return {
      UTILS: Utils,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      violationTypeList: CONST.VIOLATION_TYPE_ENUM,
      selectViolationType: 4, // 預設違規類型為 4
      violationList: [],
      selectItem: null,
      ratioData: null,
      isWaitResult: false,
      viewPort:window.innerWidth,
      isShortView:true,
      maxSelectTime: Utils.getLastestTime(),

    };
  },
  watch:{
    viewPort:{
      handler(newVal){
        if(newVal < 500){
        this.isShortView = false;
        }else{
        this.isShortView = true;
        }
      },
      immediate: true
    
    },
  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),

    violationScenicArea() {
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.VIOLATION))
    },

   

  },
  methods: {
    getElkImgHypeLink(item) {
      return Utils.transElkImgHyperLink(item.streamUrl) 
    },

    getElkImgUrl(item) {
      return Utils.transElkImgByNginx(item.streamUrl)
    },

    selectImg(item) {
      this.$refs.violationDetail.openModal()
      this.selectItem = item
      this.imgZoom()
    },

    imgZoom() {
      const img = new Image()
      img.src = this.getElkImgUrl(this.selectItem)
      img.width = CONST.IMG_MAX_WIDTH
      img.height = CONST.IMG_MAX_HEIGHT

      if (img.width > CONST.IMG_MAX_WIDTH || img.height > CONST.IMG_MAX_HEIGHT) {
        this.ratioData = this.imgZoomIn(img)
      } else {
        this.ratioData = {
          image: img
        }
      }
    },

    imgZoomIn(img) {
      let ratioWidth = 1
      let ratioHeight = 1
      const currentImgWidth = img.width
      let currentImgHeight = img.height
      let bRatioWidth = false

      if (currentImgWidth > CONST.IMG_MAX_WIDTH) {
        ratioWidth = CONST.IMG_MAX_WIDTH / currentImgWidtho
        currentImgHeight = currentImgHeight * ratioWidth
        img.width = CONST.IMG_MAX_WIDTH
        img.height = currentImgHeight
        bRatioWidth = true
      }

      if (currentImgHeight > CONST.IMG_MAX_HEIGHT) {
        ratioHeight = CONST.IMG_MAX_HEIGHT / currentImgHeight
        img.height = CONST.IMG_MAX_HEIGHT
        if (bRatioWidth) {
          img.width = CONST.IMG_MAX_WIDTH * ratioHeight
        } else {
          img.width = currentImgWidth * ratioHeight
        }
      }

      return {
        image: img,
      }
    },

    async queryCSV() {
      let violationList = "";
      if (this.selectScenicAreaId === -1) {
        alert('請選擇景區')
        return
      }
      const result = await this.searchElk();
      if(result === true){
        violationList = this.$store.getters['violation/getViolationData'];
      }else{
        violationList = [];
      }
      const csvContent = [['風景區', '設備名稱', '時間', '違規類型']]
      // const result =  this.searchElk();
      // console.log("result",result);
      // violationList = this.$store.getters['violation/getViolationData'];
      violationList.forEach(item => {
        const row = []
        row.push(item.areaName)
        row.push(item.publicPlaceName)
        row.push(this.getTime(item))
        row.push(Utils.getViolationType(item.violationType))

        csvContent.push(row)
      });

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}_違規統計.csv`
      exportCSV.genCSVFile(csvContent, fileName)
    },

    async queryElk() {
      const result = await this.searchElk();
      //若 searchElk() 完成 dispatch取值，才進行 getter取值
      if(result === true){
        this.violationList = this.$store.getters['violation/getViolationData'];
      }else{
        this.violationList = [];
      }
      this.updateTable();
    },

    async searchElk() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert('結束時間不可以小於開始時間')
        return
      }

      // if (moment(this.endTime).diff(moment(this.startTime), 'days') >= 7) {
      //   alert('一次最多查詢七天')
      //   return
      // }

      if (this.selectScenicAreaId === -1) {
        alert('請選擇景區')
        return
      }

      if (this.selectViolationType === -1) {
        alert('請選擇違規類型')
        return
      }

      const condition = {
        startTime: moment(this.startTime).startOf('minute').format(),
        endTime: moment(this.endTime).startOf('minute').format(),
        scenicAreaId: this.selectScenicAreaId,
        type: this.selectViolationType
      }

      await this.$store.dispatch('violation/getViolationData', condition)
      return true; //判斷是否滿足條件
    },

    getTime: function (item) {
      if (Utils.isEmptyObject(item.dt)) {
        return '-'
      }

      return moment(item.dt).format('YYYY/MM/DD HH:mm')
    },
    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    getPlate: function (item) {
      console.log("item",item);
      if (item === "N/A"||item === undefined) {
        return ''
      }
      return "車牌:" + item
    },

    initTable: function () {
      this.table = $("#warningCloseTable").DataTable({
        autoWidth: false, 
        columnDefs: [
        { targets: 0, width: '25%' }, 
    
        ],
        // aoColumns: [
        //   ...new Array($("#willProcessViolationTable th").length - 1),
        //   {
        //     bSortable: false,
        //   },
        // ],
    
        language: {
          url: '/json/dataTableZHTW.json'
        },
        "pageLength": 25
      });
    },
    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  async mounted() {
    this.updateTable();
    this.$_resizeEventHandler = () => {
    this.viewPort = window.innerWidth;
  };
  window.addEventListener('resize', this.$_resizeEventHandler);
  },
  
  beforeDestroy() {
  window.removeEventListener('resize', this.$_resizeEventHandler);
},
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

select:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

tbody>tr>td, tr > th {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

/* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
}

/* table不超過div */
</style>
